<template>
  <ul
    id="MAIN_NAVIGATION_BREADCRUMB"
    class="breadcrumbs"
  >
    <li
      v-for="(breadcrumb, index) in breadcrumbs"
      :key="index"
      class="breadcrumbs__item"
    >
      <template
        v-if="breadcrumbs.length-1 !== index"
      >
        <a
          class="breadcrumbs__link"
          :href="breadcrumb.link"
          v-html="breadcrumb.displayName"
        />
      </template>
      <template
        v-else
      >
        <span
          class="breadcrumbs__link breadcrumbs__link--current"
          v-html="breadcrumb.displayName"
        />
      </template>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      breadcrumbs: {
        type: Array,
      }
    }
  }
</script>
